

















































































































import Vue from "vue";
// api
import * as cwvApi from "@/features/coreWebVitals/axios";
import { getPublishers } from "@/commons/axios/publisher";
import { getClients } from "@/commons/axios/client";
// types
import {
  Publisher,
  Client,
  Domain,
  FieldDataContent,
  LabDataContent,
  FieldDataTransitionsContent,
} from "@/features/coreWebVitals/types";
import { AxiosResponse } from "axios";
import { PublishersResponse, ClientsResponse } from "@/commons/types";
import {
  DomainResponse,
  FieldDataResponse,
  FieldDataTransitionsResponse,
  LabDataResponse,
} from "@/features/coreWebVitals/types";
import { Enum } from "@/commons/enums/Type";
// util
import * as notifyUtil from "@/commons/utils/notifyUtil";
import asyncSleep from "@/commons/utils/asyncSleep";
import { isNotChrome } from "@/commons/utils/browserUtil";
import { clickDownloadUrl } from "@/commons/utils/documentHandling";
import { getLastSevenDaysIncludingToday, getDateSevenDaysAgo } from "@/commons/utils/dateHandling";
import { processFieldDataTransitions } from "@/features/coreWebVitals/utils";
// component
import PageTitle from "@/commons/components/PageTitle.vue";
import DomainButton from "@/features/coreWebVitals/components/domainButton.vue";
import SelectDomainCard from "@/features/coreWebVitals/components/selectDomainCard.vue";
import DeviceButtonToggle from "@/features/coreWebVitals/components/deviceButtonToggle.vue";
import FieldDataCard from "@/features/coreWebVitals/components/fieldDataCard.vue";
import LabDataCard from "@/features/coreWebVitals/components/labDataCard.vue";
import DialogCard from "@/commons/components/DialogCard.vue";
import ReportExecutionCard from "@/features/coreWebVitals/components/reportExecutionCard.vue";
import DownloadingDialogCard from "@/commons/components/downloadingDialogCard.vue";
import downloadLinkDialogCard from "@/commons/components/downloadLinkDialogCard.vue";
import DailyFieldDataCard from "@/features/coreWebVitals/components/dailyFieldDataCard.vue";
// enum
import { PeriodEnum } from "@/commons/enums/Period";
import { CwvDeviceTypeEnum } from "@/features/coreWebVitals/enums/CwvDeviceType";
import { AuthorityEnum } from "@/features/setting/enums/Authority";

export default Vue.extend({
  components: {
    "page-title": PageTitle,
    "domain-button": DomainButton,
    "select-domain-card": SelectDomainCard,
    "device-button-toggle": DeviceButtonToggle,
    "field-data-card": FieldDataCard,
    "lab-data-card": LabDataCard,
    "dialog-card": DialogCard,
    "report-execution-card": ReportExecutionCard,
    "downloading-dialog-card": DownloadingDialogCard,
    "download-link-dialog-card": downloadLinkDialogCard,
    "daily-field-data-card": DailyFieldDataCard,
  },
  data() {
    return {
      publishers: [] as Publisher[],
      filteredPublishers: [] as Publisher[],
      publisherInput: 0 as number,
      tmpPublisherInput: 0 as number,
      clients: [] as Client[],
      clientInput: 0 as number,
      tmpClientInput: 0 as number,
      isClientUser: false as boolean,
      domains: [] as Domain[],
      domainInput: null as number | null,
      tmpDomainInput: null as number | null,
      domainInputName: "" as string,
      periodInput: PeriodEnum.LAST_SEVEN_DAYS.value,
      loading: false as boolean,
      domainLoading: false as boolean,
      reportLoading: false as boolean,
      dailyFieldDataLoading: false as boolean,
      selectDomainDialog: false as boolean,
      deviceTypeInput: 0 as number,
      displayFieldData: {} as FieldDataContent,
      desktopFieldData: {} as FieldDataContent,
      mobileFieldData: {} as FieldDataContent,
      displayFieldTransitionsData: {} as {
        fcp: FieldDataTransitionsContent;
        lcp: FieldDataTransitionsContent;
        cls: FieldDataTransitionsContent;
        fid: FieldDataTransitionsContent;
      },
      desktopFieldTransitionsData: {} as {
        fcp: FieldDataTransitionsContent;
        lcp: FieldDataTransitionsContent;
        cls: FieldDataTransitionsContent;
        fid: FieldDataTransitionsContent;
      },
      mobileFieldTransitionsData: {} as {
        fcp: FieldDataTransitionsContent;
        lcp: FieldDataTransitionsContent;
        cls: FieldDataTransitionsContent;
        fid: FieldDataTransitionsContent;
      },
      fieldDataLastUpdateDate: "" as string,
      displayLabData: {} as LabDataContent,
      desktopLabData: {} as LabDataContent,
      mobileLabData: {} as LabDataContent,
      labDataLastUpdateDateTime: "" as string,
      startDate: getLastSevenDaysIncludingToday().startDate,
      endDate: getLastSevenDaysIncludingToday().endDate,
      retryCount: 0,
      downloadPercentage: 0,
      reportUrl: "",
      reportDialog: false,
      downloadingDialog: false,
      downloadLinkDialog: false,
      isSavingReport: false as boolean,
      isGenerateReport: false as boolean,
      isDownloadReport: false as boolean,
    };
  },
  computed: {
    periodItems(): Enum[] {
      const lang = this.$i18n.locale as string;
      return [
        { value: PeriodEnum.LAST_SEVEN_DAYS.value, text: PeriodEnum.LAST_SEVEN_DAYS.jaText },
        { value: PeriodEnum.LAST_THIRTY_DAYS.value, text: PeriodEnum.LAST_THIRTY_DAYS.jaText },
        { value: PeriodEnum.LAST_THREE_MONTHS.value, text: PeriodEnum.LAST_THREE_MONTHS.jaText },
      ];
    },
  },
  created() {
    const createdFetch = async () => {
      await this.setIsClientUser();
      await this.fetchPublishersData();
      await this.fetchClientsData();
      if (this.isClientUser) this.filteredPublishers = this.publishers;
    };
    createdFetch();
  },
  methods: {
    setIsClientUser() {
      this.isClientUser = AuthorityEnum.checkClientByValue(
        this.$store.getters["auth/getLoginUser"].type
      );
    },
    clickShowDomains() {
      this.$router.push({ name: "CwvDomains" });
    },
    async fetchPublishersData() {
      this.domainLoading = true;

      await getPublishers()
        .then((response: AxiosResponse<PublishersResponse>) => {
          this.publishers = response.data.publishers;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.publishers"));
        });

      this.domainLoading = false;
    },

    async fetchClientsData() {
      this.domainLoading = true;

      await getClients()
        .then((response: AxiosResponse<ClientsResponse>) => {
          this.clients = response.data.clients;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.clients"));
        });

      this.domainLoading = false;
    },

    async fetchDomainsData() {
      this.domainLoading = true;

      await cwvApi
        .getDomainForCwv(this.publisherInput)
        .then((response: AxiosResponse<DomainResponse>) => {
          this.domains = response.data.domains;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.domains"));
        });

      this.domainLoading = false;
    },

    async fetchFieldDataTransitions() {
      this.dailyFieldDataLoading = true;
      cwvApi
        .getFieldDataTransitions(String(this.periodInput), this.domainInput)
        .then((response: AxiosResponse<FieldDataTransitionsResponse>) => {
          this.desktopFieldTransitionsData = processFieldDataTransitions(response.data, "desktop");
          this.mobileFieldTransitionsData = processFieldDataTransitions(response.data, "mobile");
          if (this.deviceTypeInput === CwvDeviceTypeEnum.DESKTOP.value)
            this.displayFieldTransitionsData = this.desktopFieldTransitionsData;
          if (this.deviceTypeInput === CwvDeviceTypeEnum.MOBILE.value)
            this.displayFieldTransitionsData = this.mobileFieldTransitionsData;
          this.dailyFieldDataLoading = false;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(
              this.$t("general.notify.error.request.fieldDataTransitions")
            );
            // Reset
            this.desktopFieldTransitionsData = {} as {
              fcp: FieldDataTransitionsContent;
              lcp: FieldDataTransitionsContent;
              cls: FieldDataTransitionsContent;
              fid: FieldDataTransitionsContent;
            };
            this.mobileFieldTransitionsData = {} as {
              fcp: FieldDataTransitionsContent;
              lcp: FieldDataTransitionsContent;
              cls: FieldDataTransitionsContent;
              fid: FieldDataTransitionsContent;
            };
            this.dailyFieldDataLoading = false;
          }
        });
    },

    async fetchData() {
      this.loading = true;
      this.deviceTypeInput = CwvDeviceTypeEnum.DESKTOP.value;
      this.periodInput = PeriodEnum.LAST_SEVEN_DAYS.value;
      // アカウントがクライアントユーザ以外、且つフィルタでクライアントが選択されていない場合、パブリッシャーも選択しないようにする
      if (this.clientInput === 0 && !this.isClientUser) this.publisherInput = 0;
      this.tmpClientInput = this.clientInput;
      this.tmpPublisherInput = this.publisherInput;
      this.tmpDomainInput = this.domainInput;

      await Promise.all([
        cwvApi
          .getFieldData(this.domainInput)
          .then((response: AxiosResponse<FieldDataResponse>) => {
            this.desktopFieldData = response.data.fieldData.desktop;
            this.mobileFieldData = response.data.fieldData.mobile;
            this.displayFieldData = this.desktopFieldData;
            if (response.data.date === null) {
              this.fieldDataLastUpdateDate = "";
            } else {
              this.fieldDataLastUpdateDate = response.data.date;
            }
          })
          .catch(error => {
            if (error.response.status === 401) {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
              this.$router.push({ name: "Login" });
            } else {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.fieldData"));
              // Reset
              this.displayFieldData = {} as FieldDataContent;
              this.desktopFieldData = {} as FieldDataContent;
              this.mobileFieldData = {} as FieldDataContent;
            }
          }),

        cwvApi
          .getLabData(this.domainInput)
          .then((response: AxiosResponse<LabDataResponse>) => {
            this.labDataLastUpdateDateTime = "";
            this.displayLabData = response.data.labData.desktop;
            this.desktopLabData = response.data.labData.desktop;
            this.mobileLabData = response.data.labData.mobile;
            if (response.data.date_time !== null) {
              this.labDataLastUpdateDateTime = response.data.date_time;
            }
          })
          .catch(error => {
            if (error.response.status === 401) {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
              this.$router.push({ name: "Login" });
            } else {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.labData"));
              // Reset
              this.displayLabData = {} as LabDataContent;
              this.desktopLabData = {} as LabDataContent;
              this.mobileLabData = {} as LabDataContent;
            }
          }),

        cwvApi
          .getFieldDataTransitions(String(this.periodInput), this.domainInput)
          .then((response: AxiosResponse<FieldDataTransitionsResponse>) => {
            this.desktopFieldTransitionsData = processFieldDataTransitions(
              response.data,
              "desktop"
            );
            this.mobileFieldTransitionsData = processFieldDataTransitions(response.data, "mobile");
            this.displayFieldTransitionsData = this.desktopFieldTransitionsData;
          })
          .catch(error => {
            if (error.response.status === 401) {
              notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
              this.$router.push({ name: "Login" });
            } else {
              notifyUtil.notifyErrorMessage(
                this.$t("general.notify.error.request.fieldDataTransitions")
              );
              // Reset
              this.desktopFieldTransitionsData = {} as {
                fcp: FieldDataTransitionsContent;
                lcp: FieldDataTransitionsContent;
                cls: FieldDataTransitionsContent;
                fid: FieldDataTransitionsContent;
              };
              this.mobileFieldTransitionsData = {} as {
                fcp: FieldDataTransitionsContent;
                lcp: FieldDataTransitionsContent;
                cls: FieldDataTransitionsContent;
                fid: FieldDataTransitionsContent;
              };
            }
          }),
      ]).finally(() => {
        this.domainInputName = this.domains.filter(
          value => value.domainId === this.domainInput
        )[0].domainName;
        let labDataLastUpdateDate = this.labDataLastUpdateDateTime.split(" ")[0];
        if (this.fieldDataLastUpdateDate === "" && labDataLastUpdateDate === "") {
          this.startDate = getLastSevenDaysIncludingToday().startDate;
          this.endDate = getLastSevenDaysIncludingToday().endDate;
        } else if (this.fieldDataLastUpdateDate >= labDataLastUpdateDate) {
          this.startDate = getDateSevenDaysAgo(this.fieldDataLastUpdateDate);
          this.endDate = this.fieldDataLastUpdateDate;
        } else {
          this.startDate = getDateSevenDaysAgo(labDataLastUpdateDate);
          this.endDate = labDataLastUpdateDate;
        }
        this.selectDomainDialog = false;
        this.loading = false;
      });
    },
    selectDomain() {
      this.selectDomainDialog = true;
    },
    clickCancelOnselectDomainDialog() {
      this.selectDomainDialog = false;
      this.clientInput = this.tmpClientInput;
      this.publisherInput = this.tmpPublisherInput;
      this.domainInput = this.tmpDomainInput;
    },
    isNoSelectDomain() {
      return (
        Object.keys(this.displayFieldData).length === 0 &&
        Object.keys(this.displayLabData).length === 0
      );
    },
    isNullInFieldDataTransitions() {
      if (
        this.displayFieldTransitionsData.fcp?.score.includes(null) &&
        !this.displayFieldTransitionsData.fcp?.score.every(value => value === null)
      )
        return true;
      if (
        this.displayFieldTransitionsData.lcp?.score.includes(null) &&
        !this.displayFieldTransitionsData.lcp?.score.every(value => value === null)
      )
        return true;
      if (
        this.displayFieldTransitionsData.cls?.score.includes(null) &&
        !this.displayFieldTransitionsData.cls?.score.every(value => value === null)
      )
        return true;
      if (
        this.displayFieldTransitionsData.fid?.score.includes(null) &&
        !this.displayFieldTransitionsData.fid?.score.every(value => value === null)
      )
        return true;
      return false;
    },
    async clickReportExecution() {
      this.reportLoading = true;
      // TODO: レポートDLAPIまでダイアログが表示されない状態になるため、一時的にレポート登録・実行中にレポートDLのダイアログを表示
      this.downloadingDialog = true;
      this.reportDialog = false;
      this.reportUrl = "";

      let reportId: number | null = null;
      let jobId: string | null = null;

      const requestBody = {
        domainId: this.domainInput,
        device: CwvDeviceTypeEnum.getByValue(this.deviceTypeInput)?.text as "mobile" | "desktop",
        startDate: this.startDate,
        endDate: this.endDate,
      };

      await cwvApi
        .saveReport(requestBody)
        .then(res => {
          reportId = res.data.reportId;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("レポート登録に失敗しました"));
            this.downloadingDialog = false;
            this.reportLoading = false;
          }
          throw error;
        });

      this.isGenerateReport = true;
      await cwvApi
        .generateReport(reportId)
        .then(res => {
          jobId = res.data.jobId;
          this.isGenerateReport = false;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("レポート実行に失敗しました"));
            this.isGenerateReport = false;
            this.downloadingDialog = false;
            this.reportLoading = false;
          }
          throw error;
        });

      await this.downloadReport(jobId);

      this.reportLoading = false;
    },

    async downloadReport(jobId: string | null) {
      if (this.retryCount > 10) {
        notifyUtil.notifyErrorMessage("ダウンロードに失敗しました");
        this.retryCount = 0;
        this.downloadPercentage = 0;
        this.downloadingDialog = false;
        return;
      }
      this.isDownloadReport = true;

      // 5 seconds × retryCount 遅延
      await asyncSleep(this.retryCount * 5000);

      await cwvApi
        .getReportUrl(jobId)
        .then(async (res: AxiosResponse<{ report_url: string }>) => {
          if (res.status === 200 && res.data.report_url === null && this.retryCount <= 10) {
            // リトライ
            this.retryCount++;
            this.downloadPercentage += 10;
            this.downloadReport(jobId);
            return;
          }

          if (res.status === 202) {
            // リトライ
            this.retryCount++;
            this.downloadPercentage += 10;
            this.downloadReport(jobId);
            return;
          }

          if (res.status === 200) {
            this.downloadPercentage = 100;
            await asyncSleep(1000);
            notifyUtil.notifySuccessMessage("レポートのダウンロードに成功しました");
            // NOTE: Chrome 以外はダウンロードリンクを表示
            if (isNotChrome()) {
              this.reportUrl = res.data.report_url;
              this.downloadingDialog = false;
              this.downloadLinkDialog = true;
              this.isDownloadReport = false;
            }
            // NOTE: Chrome は自動的にダウンロードされるためそのままモーダルを閉じる
            else {
              this.reportUrl = res.data.report_url;
              clickDownloadUrl(
                res.data.report_url,
                `as_cwv_report(${this.startDate}-${this.endDate}).csv`
              );
              this.downloadingDialog = false;
              this.isDownloadReport = false;
            }
            this.retryCount = 0;
            this.downloadPercentage = 0;
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("レポートのダウンロードに失敗しました"));
            this.retryCount = 0;
            this.downloadPercentage = 0;
            this.downloadingDialog = false;
          }
        });
    },
    isDisplayAllNoData(): boolean {
      if (this.isNoSelectDomain() || this.loading) {
        return true;
      }
      return (
        this.displayFieldData.fcp.fcpScore === null &&
        this.displayFieldData.fid.fidScore === null &&
        this.displayFieldData.lcp.lcpScore === null &&
        this.displayFieldData.cls.clsScore === null &&
        this.displayFieldData.inp.inpScore === null &&
        this.displayFieldData.ttfb.ttfbScore === null &&
        this.displayLabData.fcp === null &&
        this.displayLabData.tti === null &&
        this.displayLabData.si === null &&
        this.displayLabData.tbt === null &&
        this.displayLabData.lcp === null &&
        this.displayLabData.cls === null
      );
    },
    isNotReportExecution() {
      return (
        (this.fieldDataLastUpdateDate === "" && this.labDataLastUpdateDateTime === "") ||
        this.isNoSelectDomain() ||
        this.isDisplayAllNoData()
      );
    },
  },
  watch: {
    clientInput() {
      let tmpSelectedPublisherIdList = [] as number[];
      // パブリッシャーに紐づいたクライアントIDが、選択されたクライアントIDと一致するもののみ、パブリッシャーフィルターで選択できるようにする
      this.publishers.forEach((publisher, index) => {
        if (
          this.clientInput !== publisher.clientId &&
          !tmpSelectedPublisherIdList.includes(publisher.publisherId)
        ) {
          this.publishers[index].disabled = true;
        } else {
          tmpSelectedPublisherIdList.push(publisher.publisherId);
          this.publishers[index].disabled = false;
        }
      });
      if (this.publisherInput !== 0 && !tmpSelectedPublisherIdList.includes(this.publisherInput)) {
        this.publisherInput = 0;
      }
      if (this.domainInput !== 0 && this.domainInput !== null) {
        this.domainInput = 0;
      }
      /**
       * NOTE: v-autocompleteのitem-disabledを使うべきだが,menu-propsで表示件数を拡張すると数秒硬直してしまう
       * そのため暫定的に他のリストに詰め直してセレクトボックスのメニューを更新している
       */
      this.filteredPublishers = this.publishers.filter(
        (publisher: Publisher) => !publisher.disabled
      );
    },
    publisherInput() {
      if (this.publisherInput !== 0) {
        this.fetchDomainsData();
      }
      if (this.domainInput !== 0 && this.domainInput !== null) {
        this.domainInput = 0;
      }
    },
    selectDomainDialog() {
      if (this.selectDomainDialog) {
        this.domainInput = this.tmpDomainInput;
      }
    },
    periodInput() {
      if (!this.isNoSelectDomain()) this.fetchFieldDataTransitions();
    },
    deviceTypeInput() {
      this.loading = true;
      this.dailyFieldDataLoading = true;
      if (this.deviceTypeInput === CwvDeviceTypeEnum.DESKTOP.value) {
        this.displayFieldData = {} as FieldDataContent;
        this.displayFieldData = this.desktopFieldData;
        this.displayLabData = {} as LabDataContent;
        this.displayLabData = this.desktopLabData;
        this.displayFieldTransitionsData = {} as {
          fcp: FieldDataTransitionsContent;
          lcp: FieldDataTransitionsContent;
          cls: FieldDataTransitionsContent;
          fid: FieldDataTransitionsContent;
        };
        this.displayFieldTransitionsData = this.desktopFieldTransitionsData;
      } else if (this.deviceTypeInput === CwvDeviceTypeEnum.MOBILE.value) {
        this.displayFieldData = {} as FieldDataContent;
        this.displayFieldData = this.mobileFieldData;
        this.displayLabData = {} as LabDataContent;
        this.displayLabData = this.mobileLabData;
        this.displayFieldTransitionsData = {} as {
          fcp: FieldDataTransitionsContent;
          lcp: FieldDataTransitionsContent;
          cls: FieldDataTransitionsContent;
          fid: FieldDataTransitionsContent;
        };
        this.displayFieldTransitionsData = this.mobileFieldTransitionsData;
      }
      this.loading = false;
      this.dailyFieldDataLoading = false;
    },
  },
});
